import {
  Box,
  ExpandableSection,
  SpaceBetween,
  TextContent,
} from "@amzn/awsui-components-react";
import ReactJson from "react-json-view";
import { AccountingEventsGroup } from "../../types";
import { AccountingEventsSummarySection } from "./AccountingEventsSummarySection";
import { decompressAndDeserializeData } from "../../helpers/compressionUtils";
import { ActionButtons } from "../common/ActionButtons";
import { useExpandableSections } from "../../hooks/useExpandableSections";

interface AccountingEventsViewProps {
  accountingGroup: AccountingEventsGroup;
  accountingEvents: AccountingEventsGroup["accountingEvents"];
  jsonViewProps: any;
  modalHandler: () => void;
}

export function AccountingEventsView({
  accountingGroup,
  accountingEvents,
  jsonViewProps,
  modalHandler,
}: AccountingEventsViewProps) {
  const initialSections = accountingEvents
    ? Object.keys(accountingEvents).reduce((acc, key) => ({ ...acc, [key]: false }), {})
    : {};

  const { expandedSections, toggleAllSections, handleSectionChange } =
    useExpandableSections(initialSections);

  const revenueEventKey = accountingEvents
    ? Object.keys(accountingEvents).find((key) => key.includes("REVENUE"))
    : null;
  const revenueEvent = revenueEventKey
    ? accountingEvents[revenueEventKey]
    : null;

  if (typeof revenueEvent?.bundleComponents === "string") {
    try {
      // decompress the bundleComponents and reassign
      revenueEvent.bundleComponents = decompressAndDeserializeData(
        revenueEvent.bundleComponents
      );
    } catch (error) {
      console.error("Failed to decompress bundle components:", error);
      revenueEvent.bundleComponents = undefined;
    }
  }

  return (
    <SpaceBetween size="l">
      <ActionButtons
        modalHandler={modalHandler}
        toggleAllSections={toggleAllSections}
        inititalExpandedState = {false}
        showRedrive={true}
      />
      {revenueEvent && <AccountingEventsSummarySection accountingGroup={accountingGroup} event={revenueEvent} />}

      {accountingEvents &&
        Object.keys(accountingEvents).map((key) => (
          <SpaceBetween size="xl" key={key}>
            <ExpandableSection
              header={
                <Box variant="h4" margin={{ top: "xxs" }}>
                  {key}
                  <br />
                  {accountingEvents[key].creationDate && (
                    <TextContent>
                      <small>
                        Created on:{" "}
                        {new Date(accountingEvents[key].creationDate)
                          .toISOString()
                          .replace("T", " ")}
                      </small>
                    </TextContent>
                  )}
                </Box>
              }
              variant="container"
              expanded={expandedSections[key]}
              onChange={handleSectionChange(key)}
            >
              <ReactJson src={accountingEvents[key]} {...jsonViewProps} />
            </ExpandableSection>
          </SpaceBetween>
        ))}
    </SpaceBetween>
  );
}
